import React from 'react'
import Cart from './Cart'
import { addToCart } from '../helper/services/cart'

const Checkout = () => {
  const [paymentMethod, setPaymentMethod] = React.useState('cod')
  return (
    <div className="grid grid-cols-6 gap-2 px-16 pt-20">
      <div className="col-span-6 p-3 lg:col-span-3 bg-darkblue">
        <Cart update={false} showCheckOut={false} />
      </div>
      <div className="col-span-6 p-3 text-pink-400 lg:col-span-3 bg-darkblue">
        DELIVERY ADDRESS
        <input
          className="w-full px-4 py-2 my-2 leading-tight text-white border-2 border-gray-200 rounded appearance-none bg-darkblue focus:outline-none focus:bg-darkblue focus:border-purple-500"
          id="inline-full-name"
          type="text"
        ></input>
        NOTE
        <input
          className="w-full px-4 py-2 my-2 leading-tight text-white border-2 border-gray-200 rounded appearance-none bg-darkblue focus:outline-none focus:bg-darkblue focus:border-purple-500"
          id="inline-full-name"
          type="text"
        ></input>
        RIDER NOTE
        <input
          className="w-full px-4 py-2 my-2 leading-tight text-white border-2 border-gray-200 rounded appearance-none bg-darkblue focus:outline-none focus:bg-darkblue focus:border-purple-500"
          id="inline-full-name"
          type="text"
        ></input>
        PAYMENT METHOD
        <div className="p-2 my-2 text-white border-2 border-gray-200 rounded">
          <div
            className="flex space-x-1 cursor-pointer"
            onClick={() => handlePaymentMethod('cod')}
          >
            <input
              type="radio"
              name=""
              id=""
              checked={paymentMethod === 'cod'}
            />
            <p>Cash on delivery</p>
          </div>
          <div
            className="flex space-x-1 cursor-pointer"
            onClick={() => handlePaymentMethod('online')}
          >
            <input
              type="radio"
              name=""
              id=""
              checked={paymentMethod === 'online'}
            />
            <p>Online Payment</p>
          </div>
        </div>
        PROMO CODE
        <div className="flex align-middle">
          <input
            className="inline-block w-full px-4 py-2 my-2 leading-tight text-white border-2 border-gray-200 rounded appearance-none bg-darkblue focus:outline-none focus:bg-darkblue focus:border-purple-500"
            id="inline-full-name"
            type="text"
          ></input>
          <div className="inline-block h-auto p-3 m-3 ml-2 text-center rounded text-darkblue bg-cyan-500">
            <p>APPLY</p>
          </div>
        </div>
        <p className="my-1">BILLING SUMMARY</p>
        <div className="grid grid-cols-6 p-2 my-1 border-2 rounded">
          <div className="col-span-4">
            <p className="text-white">Subtotal</p>
          </div>
          <div className="col-span-2">
            <p className="text-white">TK {addToCart.getSubtotal()}</p>
          </div>
        </div>
        <p className="flex my-1 text-white">
          By completing this order, I agree all
          <p className="pl-1 text-pink-400">terms and conditions.</p>
        </p>
      </div>
    </div>
  )
  function handlePaymentMethod(method: string) {
    setPaymentMethod(method)
  }
}

export default Checkout
